import React from "react";
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import GIEButton from '../GIEButton/GieButton';
import './Header.css';
import logo from "../../assets/gie.png";

class GIESideBarContent extends React.Component<any, any> {
    redirect = (endUrl: string) => {
        window.location.href = '/admin/' + endUrl
    }

    close = () => {
        this.props.close()
    }

    render() {
        return (
          <div>
              <div className="d-flex align-items-center gap-3 m-3 mb-5">
                  <div onClick={this.close}>
                      <CloseRoundedIcon className="close-icon"/>
                  </div>
                  <a href="/admin/accueil" className="header-logo">
                      <img alt='https://gie-sa.fr/' src={logo} height="60"/>
                  </a>
              </div>
              <div className="p-3">
                  <a href="https://gie-sa.fr/notre-entreprise/" className="mobile-menu">
                      <span>Notre Entreprise</span>
                      <KeyboardArrowRightIcon/>
                  </a>
                  <a href="https://gie-sa.fr/chauffage/" className="mobile-menu">
                      <span>Chauffage</span>
                      <KeyboardArrowRightIcon/>
                  </a>
                  <a href="https://gie-sa.fr/climatisation/" className="mobile-menu">
                      <span>Climatisation</span>
                      <KeyboardArrowRightIcon/>
                  </a>
                  <a href="https://gie-sa.fr/energies-renouvelables/" className="mobile-menu">
                      <span>Énergies Renouvelables</span>
                      <KeyboardArrowRightIcon/>
                  </a>
                  <a href="https://gie-sa.fr/faq/" className="mobile-menu">
                      <span>FAQ</span>
                      <KeyboardArrowRightIcon/>
                  </a>
              </div>
              <div className="d-flex flex-column gap-3 align-items-center p-3">
                  <a href="/admin/services" className="w-100">
                      <GIEButton classes={{root: 'blue-btn'}} styleClass="w-100">
                          <span>Services en ligne</span>
                          <KeyboardArrowRightIcon/>
                      </GIEButton>
                  </a>
                  <GIEButton onClick={this.close} classes={{root: 'orange-btn'}} styleClass="w-100">
                      Mon compte
                  </GIEButton>
              </div>
          </div>
        )
    }
}

export default GIESideBarContent;
